import * as React from 'react'

type SpinnerProps = {
  className?: string
  label?: string
}

export function Spinner({ className = '', label = 'Loading' }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={`inline-block w-5 h-5 rounded-full border-2 border-gold/20 border-t-gold animate-spin-slow ${className}`}
    />
  )
}
